document.addEventListener("DOMContentLoaded", function () {
    const chatTriggers = document.querySelectorAll(".freeday-open-chat");
    if (!chatTriggers.length) return;
    customElements.whenDefined("freeday-widget").then(() => {
        const widget = document.querySelector("freeday-widget");
        if (!widget || typeof widget.openChat !== "function") return;
        chatTriggers.forEach((trigger) => {
            trigger.addEventListener("click", function () {
                widget.openChat();
            });
        });
    });
});